import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";

const Router = () => {
  return (
    <Routes>
      {/* App routes */}
      <Route path="/" element={<Home />} />
    </Routes>
  );
};

export default Router;
